import api from '../../../../api/apiService';
import { ENDPOINTS } from '../../../../api/endpoints';

import {
  RiskByTeamRequest,
  TeamRiskResponse,
} from '../../types/Manager/atRiskAssociates.types';

// ======================================
// Get Risk By Team
// ======================================

export const getAtRiskByTeam = async (
  request: RiskByTeamRequest
): Promise<TeamRiskResponse[]> => {

  const payload: RiskByTeamRequest = {
    managerEmployeeCode: request.managerEmployeeCode,
    fromDate: request.fromDate,
    toDate: request.toDate,
    productivityThreshold: request.productivityThreshold,
    noOfDays: request.noOfDays,
    idleThreshold: request.idleThreshold,
    activeHoursThreshold: request.activeHoursThreshold,
    nonProdThreshold: request.nonProdThreshold,
    attendanceThreshold: request.attendanceThreshold,
  };

  console.log('==============================');
  console.log('Risk By Team Request');
  console.log(payload);
  console.log('==============================');

  try {
    const { data } = await api.post<TeamRiskResponse[]>(
      ENDPOINTS.RISK_BY_TEAM,
      payload
    );

    return data;
  } catch (error: any) {
    if (error?.response?.status === 404) {
      console.warn('Risk By Team API returned 404. Returning empty array.');
      return [];
    }

    throw error;
  }
};